import { faSliders } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type ReactElement, useRef } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { ActionsMenu } from '~/components/Global/Interactions/ActionsMenu/ActionsMenu'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { Toggle } from '~/components/Global/Interactions/Toggle/Toggle'
import { InlineOnboarding } from '~/components/Global/Onboarding/InlineOnboarding'
import { optionsPanel } from './ConversationListOptions.css'

type ConversationListOptionsProps = {
  unreadOnly: boolean
  includeCampaigns: boolean
  onUnreadOnlyChange: (value: boolean) => void
  onIncludeCampaignsChange: (value: boolean) => void
}

export const ConversationListOptions = ({
  unreadOnly,
  includeCampaigns,
  onUnreadOnlyChange,
  onIncludeCampaignsChange
}: ConversationListOptionsProps): ReactElement => {
  const anchorRef = useRef<HTMLDivElement>(null)
  const hasActiveOption = unreadOnly || includeCampaigns

  return (
    <div ref={anchorRef}>
      <ActionsMenu
        triggerOn="click"
        align="end"
        trigger={(props) => (
          <span {...props}>
            <Tooltip text="Options d'affichage" direction="top" asChild>
              <Button
                type="button"
                buttonSize="small"
                narrow
                variation={
                  hasActiveOption
                    ? ButtonVariation.PrimaryInversed
                    : ButtonVariation.Neutral
                }
                aria-label="Options d'affichage"
              >
                <FontAwesomeIcon icon={faSliders} />
              </Button>
            </Tooltip>
          </span>
        )}
      >
        {/* The menu closes on any inner click: keep it open while toggling */}
        <div className={optionsPanel} onClick={(e) => e.stopPropagation()}>
          <Toggle
            defaultState={unreadOnly}
            inputSize="small"
            label="Non lus uniquement"
            onChange={onUnreadOnlyChange}
          />
          <Toggle
            defaultState={includeCampaigns}
            inputSize="small"
            label="Campagnes"
            onChange={onIncludeCampaignsChange}
          />
        </div>
      </ActionsMenu>
      <InlineOnboarding
        title="Campagnes"
        details="Une campagne est un SMS ou un email envoyé à plusieurs destinataires en une seule fois. Pour garder vos échanges individuels lisibles, elles sont masquées par défaut : affichez-les depuis ce menu."
        anchorRef={anchorRef}
        configName="onboarding.messaging_campaigns_onboarding"
      />
    </div>
  )
}
